__turbopack_context__.v({
  "decorateImages": "ITwOla_decorateImages",
  "imageContainer": "ITwOla_imageContainer",
  "unsupportedMedia": "ITwOla_unsupportedMedia",
});
